import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, BookOpen, Mail, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function ThankYou() {
  return (
    <div className="pt-28 bg-black min-h-screen" data-testid="thank-you-page">
      <div className="max-w-2xl mx-auto px-6 md:px-12 py-16 text-center">
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", duration: 0.5 }}
          className="w-24 h-24 bg-[#D4AF37]/20 rounded-full flex items-center justify-center mx-auto mb-8"
        >
          <CheckCircle className="w-12 h-12 text-[#D4AF37]" />
        </motion.div>

        {/* Title */}
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="font-serif text-3xl md:text-4xl text-white mb-4"
        >
          Welcome to The Signal
        </motion.h1>

        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-lg text-[#999999] mb-8"
        >
          Your transformation starts now.
        </motion.p>

        {/* What's Next Box */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-[#0f0f0f] border border-[#1a1a1a] p-8 mb-8 text-left"
        >
          <h2 className="font-serif text-xl text-white mb-6 text-center">What's Next?</h2>
          
          <div className="space-y-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#D4AF37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">Check Your Email</h3>
                <p className="text-[#999999] text-sm">
                  We've sent your login details to the email you used at checkout.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#D4AF37]/20 rounded-full flex items-center justify-center flex-shrink-0">
                <BookOpen className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <div>
                <h3 className="text-white font-medium mb-1">Access Your Guide</h3>
                <p className="text-[#999999] text-sm">
                  Login with your email and start reading The Signal: Upgrade immediately.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* CTA Buttons */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <Link to="/login">
            <Button 
              className="bg-[#D4AF37] hover:bg-[#C9A030] text-black rounded-none px-8 py-4 text-sm uppercase tracking-widest w-full sm:w-auto"
            >
              Login Now
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
          
          <Link to="/">
            <Button 
              variant="outline"
              className="border-[#333] text-white hover:bg-[#1A1A1A] rounded-none px-8 py-4 text-sm uppercase tracking-widest w-full sm:w-auto"
            >
              Back to Home
            </Button>
          </Link>
        </motion.div>

        {/* Support Note */}
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="text-[#666] text-sm mt-12"
        >
          Didn't receive an email? Check your spam folder or{' '}
          <Link to="/contact" className="text-[#D4AF37] hover:underline">contact us</Link>.
        </motion.p>
      </div>
    </div>
  );
}
